import { useState } from "react";
import { X } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";

export default function ChipsInput({ value = [], onChange, placeholder, testid }) {
  const [draft, setDraft] = useState("");
  const add = () => {
    const v = draft.trim();
    if (v && !value.includes(v)) onChange([...value, v]);
    setDraft("");
  };
  return (
    <div className="mt-1.5 rounded-md border border-slate-200 bg-white p-2" data-testid={testid}>
      <div className="flex flex-wrap gap-1.5">
        {value.map((chip) => (
          <span key={chip} className="inline-flex items-center gap-1 rounded bg-slate-100 px-2 py-1 text-xs font-medium text-slate-700">
            {chip}
            <button type="button" onClick={() => onChange(value.filter((c) => c !== chip))} className="text-slate-400 hover:text-slate-700">
              <X size={12} weight="bold" />
            </button>
          </span>
        ))}
      </div>
      <Input
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); } }}
        onBlur={add}
        placeholder={placeholder || "Type and press Enter"}
        className="border-0 shadow-none focus-visible:ring-0 px-1 h-8 mt-1"
      />
    </div>
  );
}
